module.exports = __webpack_public_path__ + "img/footer_wave.c54d17ab.svg";